import { useEffect, useState, useMemo } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { deleteWithTokenBodyAPI, postWithTokenAPI } from "../util/Api";
import { ChevronLeft, ChevronRight, Heart } from "lucide-react";
import { ImageWithFallback } from "./figma/ImageWithFallback";
import { useNavigate } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogCancel,
  AlertDialogAction,
} from "./ui/alert-dialog";
import { AvatarFallback } from "./ui/avatar";
export function Horizontalslider({
  profiles = [],
  onNavigate,
  layoutType = "horizontal", // "horizontal" or "vertical"
}) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  const [isVertical, setIsVertical] = useState(layoutType === "vertical");
  const [showPrev, setShowPrev] = useState(false);
  const [showNext, setShowNext] = useState(true);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const data = useSelector((state) => state.user);
  const token = data?.userId?.accessToken;
  const id = data?.userId?.user?._id;
  const { t, i18n } = useTranslation();
  const fixImageUrl = (url) => {
    if (!url) return "";
    return url.replace(
      "s3.eu-north-1.amazonaws.com",
      "s3.ap-south-1.amazonaws.com"
    );
  };

  useEffect(() => {
    AOS.init({
      duration: 800, // animation duration in ms
      easing: "ease-in-out",
      once: true, // animate only once
      mirror: false, // do not animate out when scrolling up
    });
  }, []);
  useEffect(() => {
    setIsVertical(layoutType === "vertical");
  }, [layoutType]);
  console.log(isVertical, "ISVERTICAL");

  const [FilterProfiles, setFilterProfiles] = useState(profiles);
  useEffect(() => {
    setFilterProfiles(profiles);
  }, [profiles]);

  const profilesPerPage = isVertical ? 8 : 4;

  const visibleProfiles = useMemo(() => {
    if (isVertical) return FilterProfiles; // show ALL profiles in vertical mode
    return FilterProfiles.slice(
      currentIndex * profilesPerPage,
      (currentIndex + 1) * profilesPerPage
    );
  }, [FilterProfiles, currentIndex, profilesPerPage, isVertical]);

  const totalPages = Math.ceil(FilterProfiles.length / profilesPerPage);
  const isLastPage = currentIndex >= totalPages - 1;
  const userpng = "./Images/user.png";
  const [showLoginDialog, setShowLoginDialog] = useState(false);
  const handleNext = () => {
    if (currentIndex < totalPages - 1) {
      setDirection(1);
      setCurrentIndex((prev) => prev + 1);
      setShowPrev(true);
      setShowNext(currentIndex + 1 < totalPages - 1);
    }
  };

  const handlePrev = () => {
    if (currentIndex > 0) {
      setDirection(-1);
      setCurrentIndex((prev) => prev - 1);
      setShowPrev(currentIndex - 1 > 0);
      setShowNext(true);
    }
  };

  const handleInterestToggle = async (profile) => {
    if (!token) {
      setShowLoginDialog(true);
      return;
    } else if (profile.interest) {
      try {
        const payload = {
          from_user_id: id,
          to_user_id: profile?.user_id || profile?.basicProfile?.user_id,
        };
        const response = await deleteWithTokenBodyAPI(
          token,
          `/interest/delete`,
          payload
        );

        if (response?.statusCode === 200) {
          toast.success(t("Interest Deleted Successfully"));

          setFilterProfiles((prevProfiles) =>
            prevProfiles.map((p) =>
              (p.user_id || p?.basicProfile?.user_id) === payload.to_user_id
                ? { ...p, interest: false }
                : p
            )
          );
        } else {
          toast.error(t("Already Deleted interest"));
        }
      } catch (error) {
        toast.error(t("Something went wrong while sending interest!"));
      }
    } else {
      try {
        const payload = {
          from_user_id: id,
          to_user_id: profile?.user_id || profile?.basicProfile?.user_id,
        };

        const response = await postWithTokenAPI(
          token,
          `/interest/create`,
          payload
        );

        if (response?.statusCode === 200) {
          toast.success(t("Interest Sent Successfully"));

          setFilterProfiles((prevProfiles) =>
            prevProfiles.map((p) =>
              (p.user_id || p?.basicProfile?.user_id) === payload.to_user_id
                ? { ...p, interest: true }
                : p
            )
          );
          // console.log(updatedProfiles, "updatedProfiles")
          // setFilterProfiles(updatedProfiles);
        } else {
          toast.error(t("Already sent interest"));
        }
      } catch (error) {
        toast.error(t("Something went wrong while sending interest!"));
      }
    }
  };

  const handleViewProfile = (profile) => {
    if (!token) {
      setShowLoginDialog(true);
      return;
    } else {
      onNavigate?.(profile);
    }
  };

  const containerVariants = {
    enter: { opacity: 0, x: direction > 0 ? 100 : -100 },
    center: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: direction > 0 ? -100 : 100 },
  };

  const transitionVariants = {
    transition: { duration: 0.4, ease: "easeInOut" },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 30, scale: 0.95 },
    visible: { opacity: 1, y: 0, scale: 1 },
    exit: { opacity: 0, y: -30, scale: 0.95 },
  };

  const badgeVariants = {
    pulse: {
      scale: [1, 1.1, 1],
      transition: { repeat: Infinity, duration: 1.5 },
    },
  };

  return (
    <div
      className={`trending-slider-container ${
        isVertical ? "overflow-y-hidden" : "overflow-hidden"
      }`}
      style={{
        maxHeight: isVertical ? "auto" : "auto",
        overflowX: isVertical ? "hidden" : "auto",
      }}
    >
      <div
        className={`slider-wrapper ${
          isVertical ? "flex flex-col gap-6" : "relative"
        }`}
      >
        {/* Prev button (only horizontal) */}
        {!isVertical && (
          <AnimatePresence>
            {showPrev && (
              <motion.button
                key="prev-btn"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                onClick={handlePrev}
                className="slider-button slider-button-prev"
                aria-label="Previous profiles"
              >
                <motion.div
                  whileHover={{ scale: 1.15 }}
                  whileTap={{ scale: 0.9 }}
                  className="button-inner"
                >
                  <ChevronLeft className="button-icon" />
                </motion.div>
              </motion.button>
            )}
          </AnimatePresence>
        )}

        {/* Cards */}
        <div
          className={`cards-container ${
            isVertical
              ? "grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 xl:grid-cols-1 gap-6"
              : "flex overflow-x-auto space-x-6 no-scrollbar"
          }`}
        >
          <AnimatePresence mode="wait" custom={direction}>
            <motion.div
              key={currentIndex}
              custom={direction}
              variants={isVertical ? {} : containerVariants}
              initial="enter"
              animate="center"
              exit="exit"
              {...transitionVariants}
              className={`cards-grid ${
                isVertical ? "flex flex-wrap gap-6 w-full" : "flex"
              }`}
            >
              {visibleProfiles.map((profile, index) => (
                <motion.div
                  key={profile?._id || `profile-${index}`}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  variants={cardVariants}
                  transition={{ duration: 0.5, delay: index * 0.1 }}
                  whileHover={{ scale: 1.03 }}
                  className={`profile-card relative bg-white rounded-2xl shadow-md overflow-hidden ${
                    isVertical
                      ? "w-full sm:w-[48%] md:w-[31%]" // adjusts grid density
                      : "min-w-[250px]"
                  }`}
                >
                  {/* ❤️ Like Button */}
                  <div className="profile-badge-like">
                    <button
                      onClick={() => handleInterestToggle(profile)}
                      style={{
                        position: "relative",
                        borderRadius: "50%",
                        width: "48px",
                        height: "48px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        background: "transparent",
                        border: "none",
                        transition: "all 0.3s ease-in-out",
                      }}
                    >
                      <Heart
                        style={{
                          width: "24px",
                          height: "24px",
                          transition: "all 0.3s ease-in-out",
                          fill: profile.interest ? "#ef4444" : "#ffffff",
                          color: profile.interest ? "#ef4444" : "#ffffff",
                          transform: profile.interest
                            ? "scale(1.1)"
                            : "scale(1)",
                        }}
                      />
                    </button>
                  </div>

                  {/* 🖼️ Profile Image */}
                  <div className="profile-image-wrapper bg-white">
                    <ImageWithFallback
                      src={
                        fixImageUrl(profile?.basicProfile?.profileImage) ||
                        fixImageUrl(profile?.profileImage) ||
                        userpng
                      }
                      // alt={
                      //   userpng
                      // }
                      className="w-full h-64 object-contain"
                      style={{
                        backgroundColor: "white",
                      }}
                    />
                    {profile?.basicProfile?.name && (
                      <div className="absolute top-2 left-2 bg-gradient-to-r from-pink-500 to-rose-500 text-white text-xs font-semibold px-2 py-1 rounded-md shadow-md">
                        {t("Top Profile")}
                      </div>
                    )}
                    {/* <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent" /> */}
                    <div className="image-overlay" />
                  </div>

                  {/* 🧑 Profile Info */}
                  <div
                    className="card-content"
                    onClick={() => {
                      handleViewProfile(profile);
                    }}
                  >
                    <h3 className="profile-name ">
                      {profile?.basicProfile?.name ||
                        profile?.name ||
                        "Profile Name"}
                    </h3>
                    <p className="profile-description">
                      {profile?.basicProfile?.district ||
                        profile?.district ||
                        "Location"}
                    </p>

                    {/* Badges */}
                    <div className="badges-container">
                      {(profile?.basicProfile?.age || profile?.age) && (
                        <span className="badge">
                          {profile?.basicProfile?.age || profile?.age}{" "}
                          {t("years")}
                        </span>
                      )}
                      {profile?.basicProfile?.name && (
                        <span className="badge text-xs px-2 py-1 bg-pink-100 text-pink-600 rounded-full">
                          🔥 {t("Trending")}
                        </span>
                      )}
                    </div>

                    {/* CTA Button */}
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      style={{ paddingTop: "12px" }}
                      onClick={() => handleViewProfile(profile)}
                      className="cta-button cursor-pointer"

                      // style={{ marginTop: "1vh" }}
                    >
                      {t("View Profile")}
                    </motion.button>
                  </div>

                  <div className="card-accent-line" />
                </motion.div>
              ))}
            </motion.div>
          </AnimatePresence>
        </div>

        {/* Next button (only horizontal) */}
        {!isVertical && (
          <AnimatePresence>
            {showNext && (
              <motion.button
                key="next-btn"
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 20 }}
                onClick={handleNext}
                className="slider-button slider-button-next"
                aria-label="Next profiles"
              >
                <motion.div
                  whileHover={{ scale: 1.15 }}
                  whileTap={{ scale: 0.9 }}
                  className="button-inner"
                >
                  <ChevronRight className="button-icon" />
                </motion.div>
              </motion.button>
            )}
          </AnimatePresence>
        )}

        <AlertDialog open={showLoginDialog} onOpenChange={setShowLoginDialog}>
          <AlertDialogContent>
            <AlertDialogHeader>
              <AlertDialogTitle>{t("You’re Almost There!")}</AlertDialogTitle>
              <AlertDialogDescription>
                {t("Log in to explore profiles and start connecting")}
              </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
              <AlertDialogCancel
                onClick={() => setShowLoginDialog(false)}
                className="cursor-pointer"
              >
                {t("Cancel")}
              </AlertDialogCancel>
              <AlertDialogAction
                className="bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 cursor-pointer"
                onClick={() => {
                  setShowLoginDialog(false);
                  navigate("/login"); // 👈 navigate to login screen
                }}
              >
                {t("Login")}
              </AlertDialogAction>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialog>
      </div>
    </div>
  );
}
